var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCafverde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1648_3471)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78919 17.2936C2.66776 17.8144 2.8638 18.3638 3.31989 18.6431C6.61519 20.6605 11.8213 19.4924 15.6568 15.6569C18.8661 12.4477 20.2078 8.27885 19.3786 5.07269C19.0971 3.98395 17.7274 4.07211 16.9854 4.91709C16.9449 4.96317 16.9041 5.00864 16.8628 5.05353C16.004 5.98796 15.0184 6.61866 13.9672 7.15535C13.3004 7.4958 12.6248 7.79472 11.9245 8.10456C10.357 8.79814 8.66578 9.54643 6.67231 10.9377C4.79917 12.245 3.74452 14.2395 3.15931 15.9855C3.00249 16.4534 2.88178 16.8964 2.78919 17.2936ZM9 16.5C9.20511 17.0128 9.7892 17.266 10.2881 17.029C12.3243 16.062 14.0494 14.6617 15.4184 12.3265C15.6977 11.8501 15.494 11.247 15 11C14.506 10.753 13.9094 10.9568 13.6248 11.4301C12.5201 13.2673 11.1726 14.3748 9.54357 15.1682C9.04703 15.41 8.79489 15.9872 9 16.5Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.26299 15.3499C1.17855 15.6018 0.83559 15.6229 0.751886 15.3707C-0.329327 12.1133 0.983784 7.70255 4.34311 4.34323C7.8056 0.880739 12.3851 -0.407928 15.6674 0.858407C16.3424 1.11881 16.5982 1.91638 16.2352 2.54217C15.9716 2.99664 15.6892 3.37497 15.3903 3.70015C14.7522 4.39439 13.9941 4.89605 13.0578 5.37407C12.5409 5.63797 11.9524 5.89904 11.3053 6.18607C9.67984 6.90712 7.68493 7.79206 5.52769 9.29761C3.1639 10.9473 1.91856 13.394 1.26299 15.3499Z",
    fill: "#653024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1648_3471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafverde);
export default __webpack_public_path__ + "static/media/café verde.2fc65f926016029b4a24c971f1480c82.svg";
export { ForwardRef as ReactComponent };